import { Avatar, Card, Col, Row, Typography } from "antd";
import { MenuButton } from "./MenuButton";
import { UserOutlined } from "@ant-design/icons";
import { getColor, getGradient } from "../../resources/theme";
import { useAuth } from "../../../hooks/useAuth";
import { useHistory } from "react-router";
import React, { useDispatch } from "reactn";
import styled from "styled-components";

const { Meta } = Card;
const { Paragraph } = Typography;

export const DrawerUserCard = ({ user, setOpen }) => {
	const { isLoggedIn } = useAuth();
	const { name, email } = user;
	const logout = useDispatch("logout");
	const history = useHistory();

	return (
		<StyledCard bordered={false}>
			<Meta
				avatar={<Avatar size={64} icon={<UserOutlined />} />}
				title={
					isLoggedIn ? (
						<UserInfo>
							<Row>
								<Col span={24}>
									<Paragraph
										className="userName"
										ellipsis
										strong
										style={{ margin: 0 }}
									>
										{name || "Usuario"}
									</Paragraph>
								</Col>
							</Row>
							<Row>
								<Col span={24}>
									<Paragraph
										className="userEmail"
										strong
										ellipsis
									>
										{email}
									</Paragraph>
								</Col>
							</Row>
						</UserInfo>
					) : (
						<Row>
							<Col span={24}>
								<Paragraph></Paragraph>
							</Col>
						</Row>
					)
				}
				description={
					isLoggedIn ? (
						<MenuButton
							onClick={() => {
								setOpen(false);
								logout().then(() => {
									history.push("/welcome");
								});
							}}
							menuButton={{
								text: "Cerrar sesión",
								shape: "round", // theme
								action: "logout",
							}}
						></MenuButton>
					) : (
						<MenuButton
							onClick={() => {
								setOpen(false);
								logout().then(() => {
									history.push("/welcome");
								});
							}}
							menuButton={{
								link: "/signin",
								text: "Iniciar sesión",
								shape: "round", // theme
							}}
						></MenuButton>
					)
				}
			/>
		</StyledCard>
	);
};

const StyledCard = styled(Card)`
	.ant-card-body {
		margin: 48px 0 !important;
		background-color: ${getColor("elementBg")};
	}
	.ant-card-meta {
		.ant-btn {
			background-color: ${getColor("elementBg")};
			color: ${getColor("warningAlt")};
			border-color: ${getColor("warningAlt")};
		}
	}
`;

const UserInfo = styled.div`
	.userName {
		color: ${getColor("primary")};
	}
	.userEmail {
		color: ${getColor("secondaryDark")};
	}
`;

// const StyledAvatar = styled(Avatar)`
// 	box-shadow: ${getGradient("shadow")};
// `;
